import { createSlice } from '@reduxjs/toolkit';

// The project email composer as a dialog that any scene can open over
// itself (ProjectEmailDialog, hosted once in App): the user writes and sends
// a message from the project's own address without leaving what they were
// doing. The opener passes the project and what the message is for; the
// dialog loads the rest (signature, contacts) on its own.
export const projectEmailDialogSlice = createSlice({
  name: 'projectEmailDialog',
  initialState: {
    isOpen: false,
    // { projectKey, projectId, projectName } — the project the message is
    // sent from.
    project: null,
    // Optional prefill: { to, cc, bcc, subject, body } (body is html).
    initialMessage: null,
    // A project bank archive job the message carries the download link of:
    // { archiveJobId }. The dialog then writes the link message, fills in its
    // tokens as the job progresses, and hands the message to the backend,
    // which sends it once the archive is ready.
    archiveJob: null,
  },
  reducers: {
    openProjectEmailDialog(state, action) {
      const { project, initialMessage, archiveJob } = action.payload || {};
      state.isOpen = true;
      state.project = project || null;
      state.initialMessage = initialMessage || null;
      state.archiveJob = archiveJob || null;
    },
    closeProjectEmailDialog(state) {
      state.isOpen = false;
      state.project = null;
      state.initialMessage = null;
      state.archiveJob = null;
    },
  },
});

export const { openProjectEmailDialog, closeProjectEmailDialog } =
  projectEmailDialogSlice.actions;

export const selectProjectEmailDialog = (state) => state.projectEmailDialog;
